const variantElements = document.querySelectorAll('.variantItem');
const variantNameSpan = document.querySelector('.variant-name');
const galleryImages = document.querySelectorAll('.gallery-image');

let originalVariantName = variantNameSpan.textContent;
let originalGalleryImageSrcsets = [];
let originalGalleryImageSrcs = [];
let codeEnabled = true;
let hoverToken = 0; // used to know if we're still hovered on same thing

// Store originals
galleryImages.forEach((image) => {
  originalGalleryImageSrcsets.push(image.srcset);
  originalGalleryImageSrcs.push(image.src);
});

variantElements.forEach((variantElement) => {
  variantElement.addEventListener('mouseover', () => {
    if (!codeEnabled) return;

    hoverToken++; // new hover session
    const thisToken = hoverToken;

    // Update label
    variantNameSpan.textContent = variantElement.getAttribute('data-name');

    const variantImage = variantElement.querySelector('.variant-image');
    if (!variantImage) return;

    // LQ is the thumbnail src (already loaded)
    const lowSrc = variantImage.getAttribute('src');
    // HQ is what you were already using
    const highSrc = variantImage.getAttribute('data-fullsize-src');

    // 1️⃣ Immediately show LQ (no network)
    galleryImages.forEach((image) => {
      image.src = lowSrc;
      image.srcset = lowSrc;
    });

    // 2️⃣ Preload HQ, then swap once it's ready — but only if still hovered
    const preload = new Image();
    preload.src = highSrc;
    preload.onload = () => {
      if (thisToken !== hoverToken) return; // user moved off / to another variant

      galleryImages.forEach((image) => {
        image.src = highSrc;
        image.srcset = highSrc;
      });
    };
  });

  variantElement.addEventListener('mouseout', () => {
    if (!codeEnabled) return;

    hoverToken++; // invalidate any pending HQ swap

    // Restore text
    variantNameSpan.textContent = originalVariantName;

    // Restore original gallery images
    galleryImages.forEach((image, i) => {
      if (originalGalleryImageSrcs[i]) {
        image.src = originalGalleryImageSrcs[i];
      }
      if (originalGalleryImageSrcsets[i]) {
        image.srcset = originalGalleryImageSrcsets[i];
      }
    });
  });
});

const ratingBadge = document.querySelector('.rating-badge');
if (ratingBadge) {
  ratingBadge.addEventListener('click', () => {
    codeEnabled = false;
    setTimeout(() => {
      codeEnabled = true;
    }, 4000);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.querySelector('.variantItem.current');
  const container = document.querySelector('.variant-picker__options');

  if (targetElement && container) {
    const scrollOffset = 0;
    const scrollPosition = targetElement.offsetLeft - container.offsetLeft - scrollOffset;
    container.scrollLeft = scrollPosition;
  }
});